import { UserVerificationNotes } from "./cycle-verification-notes.model";

export class UserVerification {
    VerificationID: string;
    StageID: string;
    RefId: string;
    VerificationStatus: number;
    ReopenStageId: string;
    VerifiedBy: string;
    VerifiedByName: string;
    VerifiedDate: Date;
    CompletedDate: Date;
    CompletedDateAsStart:number;
    ShouldSubmitToPerms:boolean;
    ShouldSendNotifications:boolean;
    Notes?: UserVerificationNotes;
}